var React = require('react');

function Contact (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"circle-path","d":"M 0, 50\n            a 50,50 0 1,0 100,0\n            a 50,50 0 1,0 -100,0","fill":"none"})),React.createElement("text",{"key":1},React.createElement("textPath",{"xlinkHref":"#circle-path","textAnchor":"start"},"\n            Contact Us\n            Contact Us\n            Contact Us\n            Contact Us\n        "))]);
}

Contact.defaultProps = {"viewBox":"0 0 100 100","fill":"#231f20"};

module.exports = Contact;

Contact.default = Contact;
